import React, { useEffect, useState } from 'react'
import { Button } from 'antd'

import { useLocation, useNavigate } from 'react-router-dom'
import { getGameDetails } from '../redux'

// Component
import Header from '../components/Header'
import ScoreCardTeam from '../components/cards/ScoreCardTeam'
import ScoreCardPlayer from '../components/cards/ScoreCardPlayer'
import Loader from '../components/Loader'
import Empty from '../components/Empty'

import { useSelector } from 'react-redux'
import HeadingAndDate from '../components/Pagination/HeadingAndDate'
import MainHeader from '../components/MainHeader'

const GameDetails = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const { state } = useLocation()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(null)

  const navigate = useNavigate()

  useEffect(() => {
    getData()
  }, [SETTING.date])

  const getData = async () => {
    setLoading(true)
    const res = await getGameDetails({
      teamId: state.teamId,
      date: SETTING.date,
    })
    if (res) {
      setData(res)
    }
    setLoading(false)
  }

  return (
    <div className='game_details'>
      <MainHeader />

      <section className='schedule_box2'>
        <h1>League Scores </h1>
        <Button
          type='primary'
          onClick={() => {
            navigate(-1)
          }}
        >
          Back
        </Button>
      </section>

      <main className='practice_squad_container wrapper'>
        <section className='team-cards-container'>
          <ScoreCardTeam alignment='left' data={state} />
        </section>

        {loading ? (
          <Loader />
        ) : (
          <section style={{ overflowX: 'auto' }}>
            <Heading text={'1st Line'} />
            <div className='player-cards-container'>
              {data?.line1Players?.length > 0 ? (
                <>
                  {data?.line1Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no line 1'} />
              )}
            </div>
            <Heading text={'2nd Line'} />
            <div className='player-cards-container'>
              {data?.line2Players?.length > 0 ? (
                <>
                  {data?.line2Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no line 2'} />
              )}
            </div>
            <Heading text={'3rd Line'} />
            <div className='player-cards-container'>
              {data?.line3Players?.length > 0 ? (
                <>
                  {data?.line3Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no line 3'} />
              )}
            </div>
            <Heading text={'4th Line'} />
            <div className='player-cards-container'>
              {data?.line4Players?.length > 0 ? (
                <>
                  {data?.line4Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no line 4'} />
              )}
            </div>
            <Heading text={'1st Pairing'} />
            <div className='player-cards-container'>
              {data?.pair1Players?.length > 0 ? (
                <>
                  {data?.pair1Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no pairing 1'} />
              )}
            </div>
            <Heading text={'2nd Pairing'} />
            <div className='player-cards-container'>
              {data?.pair2Players?.length > 0 ? (
                <>
                  {data?.pair2Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no pairing 2'} />
              )}
            </div>
            <Heading text={'3rd Pairing'} />
            <div className='player-cards-container'>
              {data?.pair3Players?.length > 0 ? (
                <>
                  {data?.pair3Players?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'no pairing 3'} />
              )}
            </div>
            <Heading text={'Extra'} />
            <div className='player-cards-container'>
              {data?.extraPlayers?.length > 0 ? (
                <>
                  {data?.extraPlayers?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'No Extra Defender'} />
              )}
            </div>
            <Heading text={'Goalie'} />
            <div className='player-cards-container'>
              {data?.goaliePlayers?.length > 0 ? (
                <>
                  {data?.goaliePlayers?.map((v, i) => {
                    return <ScoreCardPlayer key={i} data={v} />
                  })}
                </>
              ) : (
                <Empty text={'No Goalie'} />
              )}
            </div>
          </section>
        )}
      </main>
    </div>
  )
}

const Heading = ({ text }) => {
  return (
    <section className='starters-sec'>
      <h3>{text}</h3>
    </section>
  )
}

export default GameDetails
